import {AppRegistry} from 'react-native';
import SimuCST from './pages/SimuCST';
import SimuCSTA from './pages/SimuCSTA';
import SimuCSTM from './pages/SimuCSTM';
import SimuIF from './pages/SimuIF';
import SimuPAT from './pages/SimuPAT';
import SimuTMC from './pages/SimuTMC';
import SimuCSIS from './pages/SimuCSIS';
import SimuAQSMI from './pages/SimuAQSMI';
import {name as appName} from './app.json';

// if (document.getElementById('csis')) {
//   AppRegistry.registerComponent(appName, () => SimuCSIS);
//   AppRegistry.runApplication(appName, {
//     rootTag: document.getElementById('csis'),
//   });
// }
//
// if (document.getElementById('cst')) {
//   AppRegistry.registerComponent(appName, () => SimuCST);
//   AppRegistry.runApplication(appName, {
//     rootTag: document.getElementById('cst'),
//   });
// }
//
// if (document.getElementById('csta')) {
//   AppRegistry.registerComponent(appName, () => SimuCSTA);
//   AppRegistry.runApplication(appName, {
//     rootTag: document.getElementById('csta'),
//   });
// }
//
// if (document.getElementById('cstm')) {
//   AppRegistry.registerComponent(appName, () => SimuCSTM);
//   AppRegistry.runApplication(appName, {
//     rootTag: document.getElementById('cstm'),
//   });
// }
//
// if (document.getElementById('if')) {
//   AppRegistry.registerComponent(appName, () => SimuIF);
//   AppRegistry.runApplication(appName, {
//     rootTag: document.getElementById('if'),
//   });
// }
//
// if (document.getElementById('pat')) {
//   AppRegistry.registerComponent(appName, () => SimuPAT);
//   AppRegistry.runApplication(appName, {
//     rootTag: document.getElementById('pat'),
//   });
// }
//
// if (document.getElementById('tmc')) {
//   AppRegistry.registerComponent(appName, () => SimuTMC);
//   AppRegistry.runApplication(appName, {
//     rootTag: document.getElementById('tmc'),
//   });
// }

if (document.getElementById('aqsmi')) {
  AppRegistry.registerComponent(appName, () => SimuAQSMI);
  AppRegistry.runApplication(appName, {
    rootTag: document.getElementById('tmc'),
  });
}
